import React from 'react';
import Table from '../../components/common/Table';
import { FirearmLooseBarrelTypeDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface FirearmLooseBarrelTypeTableProps {
  data: FirearmLooseBarrelTypeDTO[];
  handleEdit: (row: FirearmLooseBarrelTypeDTO) => void;
  handleDelete: (row: FirearmLooseBarrelTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FirearmLooseBarrelTypeTable: React.FC<
  FirearmLooseBarrelTypeTableProps
> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },

        {
          label: 'Not On List',
          key: 'notOnList',
          render: (row: FirearmLooseBarrelTypeDTO) =>
            renderBooleanBadge(row.notOnList ?? false, 'Yes', 'No'),
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: FirearmLooseBarrelTypeDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Position',
          key: 'displayPosition',
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (createdUtc: Date) =>
            convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FirearmLooseBarrelTypeTable;
